import { useQuery } from 'react-query';
import { novaPoshtaSettingsAPI } from '../services/api';

interface UseNovaPoshtaConfiguredResult {
  configured: boolean;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
}

/**
 * Хук для перевірки, чи збережений API ключ Нової Пошти.
 * Кешує результат на 5 хвилин.
 */
export const useNovaPoshtaConfigured = (): UseNovaPoshtaConfiguredResult => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['nova-poshta-settings'],
    queryFn: () => novaPoshtaSettingsAPI.get(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  });

  return {
    configured: data?.api_key_set ?? false,
    isLoading,
    isError,
    error: error instanceof Error ? error : null,
  };
};
